import type { Feature } from './types';

import services from '../services';

const title = 'Export data to CSV file';
const LOCAL_DEV_RECAPTCHA_SITE_KEY = 'local-dev';

const isRemoteCsvExportEnabled = Boolean(
  services.reCaptchaV2.siteKey &&
  services.reCaptchaV2.siteKey !== LOCAL_DEV_RECAPTCHA_SITE_KEY,
);

const config: Feature<{ reCaptcha: { siteKey: string } }> = (() => {
  if (isRemoteCsvExportEnabled) {
    return Object.freeze({
      title,
      isEnabled: true,
      reCaptcha: {
        siteKey: services.reCaptchaV2.siteKey as string,
      },
    });
  }
  return Object.freeze({
    title,
    isEnabled: false,
  });
})();

export default config;
